import { useRef, useCallback } from "react";

const useFieldInspector = () => {
  const inspectorRef = useRef(null);
  const containerRef = useRef(null);

  const inspect = useCallback((cellData) => {
    inspectorRef.current?.show(cellData);
  }, []);

  return { inspectorRef, inspect, containerRef };
};

export default useFieldInspector;
